import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';

// Constants
import QueryParamsConstants from 'Shared/constants/QueryParams.constants';

// Types
import { FeedbackRecognitionTemplateTypes } from 'Shared/constants/types';

// Utils
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';

// Components
import SelectUserModal, { FlowType as FlowTypeType } from 'Dashboard/components/GiveFeedbackPage/SelectUserModal';
import GiveRecognitionModal from 'Shared/components/modals/GiveRecognitionModal/GiveRecognitionModal';

export type FlowType = FlowTypeType;

type Props = {
  flow: FlowType;
  isOpen: boolean;
  toggleIsOpen: () => void;
  template?: FeedbackRecognitionTemplateTypes | string;
  reviewTemplateSlug?: string;
};

const GiveFeedbackOrKudosModal = ({ flow, isOpen, toggleIsOpen, template, reviewTemplateSlug }: Props) => {
  const history = useHistory();

  const [selectedUser, setSelectedUser] = useState(null);
  const [isSelectUserModalOpen, setIsSelectUserModalOpen] = useState<boolean>(false);
  const [isKudosModalOpen, setIsKudosModalOpen] = useState<boolean>(false);

  const emptyRecognitionRequest = {
    id: null,
    employee: { id: !selectedUser?.isWorkspace ? selectedUser?.id : null },
    workspaceUuid: selectedUser?.isWorkspace ? selectedUser?.workspaceId : null,
  };

  const handleCloseFlow = () => {
    setSelectedUser(null);
    setIsKudosModalOpen(false);
    toggleIsOpen();
  };

  const handleOnSuccess = () => {
    if (selectedUser?.slug) {
      history.push(PageUrlsUtils.makeUserProfilePageUrl(selectedUser.slug));
    }
  };

  useEffect(() => {
    if (!isOpen) return;

    if (!selectedUser) setIsSelectUserModalOpen(true);
    else setIsSelectUserModalOpen(false);

    if (selectedUser && flow === 'kudos') setIsKudosModalOpen(true);

    if (selectedUser && flow === 'feedback' && template) {
      history.push({
        pathname: PageUrlsUtils.makeFeedbackFormUrl(selectedUser.workspaceId),
        search: `template=${template}${reviewTemplateSlug ? `&review_template_slug=${reviewTemplateSlug}` : ''}`,
      });
    }

    if (selectedUser && flow === 'feedback' && !template) {
      history.push({
        pathname: PageUrlsUtils.makeFeedbackRequestUrl(selectedUser.workspaceId),
        search: `${QueryParamsConstants.HIDE_KUDOS_CARD}=true`,
      });
    }
  }, [selectedUser, isOpen]);

  if (!flow || !isOpen) return null;

  return (
    <>
      <SelectUserModal
        isOpen={isSelectUserModalOpen}
        toggleModal={handleCloseFlow}
        handleContinue={setSelectedUser}
        type={flow}
      />
      {isKudosModalOpen && (
        <GiveRecognitionModal
          choosenRequest={emptyRecognitionRequest}
          isOpen={isKudosModalOpen}
          onModalToggle={handleCloseFlow}
          onSuccess={handleOnSuccess}
        />
      )}
    </>
  );
};

export default GiveFeedbackOrKudosModal;
